export const orderFormatedNumber = (number) =>
!number || isNaN(number)?'0,00':number.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
